import { render, staticRenderFns } from "./ConversationDateMarker.vue?vue&type=template&id=18f6d336&scoped=true"
import script from "./ConversationDateMarker.vue?vue&type=script&lang=js"
export * from "./ConversationDateMarker.vue?vue&type=script&lang=js"
import style0 from "./ConversationDateMarker.vue?vue&type=style&index=0&id=18f6d336&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f6d336",
  null
  
)

export default component.exports